import React from 'react';

interface EventStatusBadgesProps {
    isActive: boolean;
    isDueNow: boolean;
    isOverdue: boolean;
    themeColor: string;
}

export const EventStatusBadges: React.FC<EventStatusBadgesProps> = ({
    isActive, isDueNow, isOverdue, themeColor
}) => {
    return (
        <>
            {isActive && (
                <span style={{ 
                    fontSize: '9px', fontWeight: '900', color: themeColor, 
                    backgroundColor: `${themeColor}22`, padding: '2px 6px', 
                    borderRadius: '4px', border: `1px solid ${themeColor}44`, marginLeft: '4px' 
                }}>
                    LIVE
                </span>
            )}
            {isDueNow && (
                <span style={{ 
                    fontSize: '9px', fontWeight: '900', color: '#000', 
                    backgroundColor: themeColor, padding: '2px 6px', 
                    borderRadius: '4px', marginLeft: '4px' 
                }}>
                    DUE NOW
                </span>
            )}
            {isOverdue && (
                <span style={{ 
                    fontSize: '9px', fontWeight: '900', color: '#fff', 
                    backgroundColor: '#ef4444', padding: '2px 6px', 
                    borderRadius: '4px', marginLeft: '4px' 
                }}>
                    OVERDUE
                </span>
            )}
        </>
    );
};
